import React, { useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useHotkeys } from 'react-hotkeys-hook';
import Dashboard from './dashboard/Dashboard';
import ProductRoutes from './product/ProductRoutes';
import CustomerRoute from './customer/CustomerRoute';
import InvoiceRoute from './invoices/InvoiceRoute';
import OrderRoute from './orders/OrderRoute';
import SettingRoute from './setting/SettingRoute';
import Error404 from '../Error404';
import { LogoProvider } from './logo/LogoContext';
import PaymentRoute from './payment/PaymentRoute';
import ExpenseRoute from './expenses/ExpenseRoute';
import { HOT_KEYS } from '../../data/constant';
import { UserProvider } from './user/UserContext';
import BillRoute from './bill/BillRoute';
import ReportRoute from './report/ReportRoute';
import QuoteRoute from './quote/QuoteRoute';
import CreditNotesRoute from './credit-note/CreditNotesRoute';

const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  const isAdminAuthenticated = token ? true : false;
  return isAdminAuthenticated;
};

const keyboardShortcuts = HOT_KEYS;

const AdminRoutes = () => {
  useEffect(() => {
    window.focus();
  }, []);

  return isAuthenticated() ? (
    <LogoProvider>
      <UserProvider>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/product/*" element={<ProductRoutes />} />
          <Route path="/:customerType/*" element={<CustomerRoute />} />
          <Route path="/invoices/*" element={<InvoiceRoute />} />
          <Route path="/po/*" element={<OrderRoute />} />
          <Route path="/setting/*" element={<SettingRoute />} />
          <Route path="/payment/*" element={<PaymentRoute />} />
          <Route path="/expense/*" element={<ExpenseRoute />} />
          <Route path="/bill/*" element={<BillRoute />} />
          <Route path="/quotes/*" element={<QuoteRoute />} />
          <Route path="/reports/*" element={<ReportRoute />} />
          <Route path="/credit-note/*" element={<CreditNotesRoute />} />
          <Route path="*" element={<Error404 />} />
        </Routes>

        {keyboardShortcuts.map(({ key, route }) => (
          <HotKey key={key} combo={key} route={route} />
        ))}
      </UserProvider>
    </LogoProvider>
  ) : (
    <Navigate to="/login" replace />
  );
};

const HotKey = ({ combo, route }) => {
  useHotkeys(combo, () => navigateTo(route));

  const navigateTo = (path) => {
    window.location.href = path;
  };

  return null;
};

export default AdminRoutes;
